import React from 'react';
import { Rule } from '../../../../dtos/version.dto';
import { DynamicPlacementPopover } from '../../../shared/dynamic-placement-popover/dynamic-placement-popover';
import './rule-name-popover.scss';

interface RuleNameProps {
    ruleData: Rule;
}
export const RuleNamePopover: React.FC<RuleNameProps> = ({ ruleData}) => {

    const formatDescription = (description: string) => {
       return description?.replace('. ', '.\n');
    };
    
    return <div className={'rule-name'}>
        <DynamicPlacementPopover key={ruleData.displayName} content={formatDescription(ruleData.description)}
                                     overlayClassName="rule-desc" defaultZonePlacement="bottomRight"
                                     contentHeight={20}>
            {ruleData.disabled && <div className={'status-label disable'}>Inactive</div>}
            {ruleData.modified && <div className={'status-label modified'}>Modified</div>}
            <div className={'rule-cell'}>{ruleData.displayName}</div>
        </DynamicPlacementPopover>
    </div>;
};